/** Amazon authorization and Shop activation for a seller who has no Shop yet.
 *
 * The same flow the login page continues into — this route is where a seller
 * lands when they come back to finish, or when the Ads popup could not relay
 * its result to an opener.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { AuthPageLayout } from "@/components/auth/auth-page-layout";
import { OnboardingFlow } from "@/components/onboarding/onboarding-flow";
import { fetchAuthUser, hydrateAuthUser } from "@/lib/auth-api";

export const Route = createFileRoute("/onboarding")({
  beforeLoad: async () => {
    let user: Awaited<ReturnType<typeof fetchAuthUser>>;
    try {
      user = await fetchAuthUser();
    } catch {
      throw redirect({ to: "/login" });
    }
    hydrateAuthUser(user);
    // Onboarding is only for a seller with nothing connected yet; everyone
    // else manages authorizations in Settings.
    if (user.shops.length > 0) throw redirect({ to: "/" });
  },
  component: OnboardingPage,
});

function OnboardingPage() {
  return (
    <AuthPageLayout>
      <OnboardingFlow />
    </AuthPageLayout>
  );
}
